var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapPointer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 4,
    fill: "#1A2A55"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9993 5.66699C10.7743 5.66699 8.16602 8.27533 8.16602 11.5003C8.16602 15.8753 13.9993 22.3337 13.9993 22.3337C13.9993 22.3337 19.8327 15.8753 19.8327 11.5003C19.8327 8.27533 17.2243 5.66699 13.9993 5.66699ZM13.9993 13.5837C12.8493 13.5837 11.916 12.6503 11.916 11.5003C11.916 10.3503 12.8493 9.41699 13.9993 9.41699C15.1493 9.41699 16.0827 10.3503 16.0827 11.5003C16.0827 12.6503 15.1493 13.5837 13.9993 13.5837Z",
    fill: "#3A66FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPointer);
export default __webpack_public_path__ + "static/media/mapPointer.40469b26fb746c6742c82aa71dd55712.svg";
export { ForwardRef as ReactComponent };